import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Game from './Game';
import Button from './components/Button';
import Title from './components/Title';
import Ruleta from './components/Ruleta';
import Messages from './components/Messages';
import Instrucciones from './components/Instrucciones';
import './Start.css';


function Start() {
  const [messageState, setMessageState] = useState(false);
  useEffect(() => {
    document.querySelector('.ruleta__img').style.animation = 'girar 15s linear infinite';
  });

  function startGame() {
    ReactDOM.render(<Game />, document.getElementById('root'));
  }

  function mostrarOcultarInstrucciones() {
      setMessageState(!messageState);
  }

  let mejorPuntuacion = localStorage.getItem('mejorpuntuacion');
  if (mejorPuntuacion === null) {
    mejorPuntuacion = 0;
  }

  return (
    <div className="start__container">
        {messageState
          ? <Messages text={Instrucciones} state={messageState} onClickHandler={mostrarOcultarInstrucciones} />
          : null }

      <header className="start__header">

        <Title text="La Ruleta de la Suerte" />

      </header>

      <main className="start__main">

        <Ruleta />

        <div className="start__bottom">

          <div className="mejor-puntuacion">
            <img className="star" src={`${process.env.PUBLIC_URL}/img/star.png`} alt="star" />
            Mejor Puntuación: {mejorPuntuacion}
            <img className="star" src={`${process.env.PUBLIC_URL}/img/star.png`} alt="star" />
          </div>

          <Button text="Comenzar partida" type="button-start" onClickHandler={startGame} />

          <Button text="Instrucciones" type="button-start" onClickHandler={mostrarOcultarInstrucciones} />

        </div>

      </main>

    </div>
  );
}

export default Start;
